// extracted by mini-css-extract-plugin
module.exports = {"loading":"LoadingV2_loading__WOVXU","button-loading":"LoadingV2_button-loading__18o61","icon":"LoadingV2_icon__30jFB"};